import { render } from "./LeadId.vue?vue&type=template&id=16429fa3&scoped=true&ts=true"
import script from "./LeadId.vue?vue&type=script&lang=ts"
export * from "./LeadId.vue?vue&type=script&lang=ts"

import "./LeadId.vue?vue&type=style&index=0&id=16429fa3&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16429fa3"]])

export default __exports__